import { Token } from '@donaswap/sdk'
import { bscTokens } from '@donaswap/tokens'
import { bscWarningTokens } from 'config/constants/warningTokens'

const { bondly, itam, ccar, bttold, abnbc } = bscTokens
const { pokemoney, free, safemoon, gala, xcad } = bscWarningTokens

interface WarningTokenList {
  [key: string]: Token
}

const SwapWarningTokens = <WarningTokenList>{
  safemoon,
  bondly,
  itam,
  ccar,
  bttold,
  pokemoney,
  free,
  gala,
  abnbc,
  xcad,
}

export default SwapWarningTokens
